import React from 'react';
import { MarketingQuestionsForm } from 'src/domains/players/webview/components/Account/preferencesTab/MarketingQuestionsForm';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Header, Separator, Wrapper } from './PreferencesTab.style';
import { SettingsFormWrapper } from 'src/domains/players/webview/components/Account/preferencesTab/SettingsForm';
import { QuestionAnswers } from './types';
import { ContactPreferences } from './contactPreferences/ContactPreferences';
import { MarketingQuestionsState } from 'src/domains/players/state/MarketingQuestionsState';
import { useCommon } from 'src/domains/common/Common';

export const PreferencesTab = observer('PreferencesTab', () => {
    const common = useCommon();
    const marketingQuestionsState = MarketingQuestionsState.get(common);

    return (
        <Wrapper>
            <SettingsFormWrapper />
            <ContactPreferences />
            {marketingQuestionsState.showMarketingQuestions && (
                <>
                    <Separator />
                    <div>
                        <Header data-test='marketing-header'>
                            <I18n
                                langKey='account.preferences-tab.marketing-title'
                                defaultText='Marketing'
                            />
                        </Header>
                        <MarketingQuestionsForm marketingQuestionsState={marketingQuestionsState} />
                    </div>
                </>
            )}
        </Wrapper>
    );
});

export { QuestionAnswers };
